<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
            <div class="container">
                <a class="navbar-brand js-scroll-trigger" href="#" onclick="$('html,body').scrollTop(0); return false">RowerUp</a>
                <button class="navbar-toggler navbar-toggler-right text-uppercase font-weight-bold bg-primary text-white rounded"
                        type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive"
                        aria-expanded="false" aria-label="Toggle navigation">Menu<i class="fas fa-bars ml-1"></i></button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav text-uppercase ml-auto">

                        <li class="nav-item mx-0 mx-lg-1">
                            <a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" :href="pricingUrl">Pricing</a>
                        </li>
                        <li class="nav-item mx-0 mx-lg-1">
                            <a style="background-color: transparent"
                               class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#contact">
                                Contact US</a>
                        </li>
                        <li v-if="!store.myUser" class="nav-item mx-0 mx-lg-1">
                            <a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" :href="signUpUrl">Sign up</a>
                        </li>
                        <li v-if="!store.myUser" class="nav-item mx-0 mx-lg-1">
                            <a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" :href="loginUrl">Sign in</a>
                        </li>
                        <li v-if="store.myUser" class="nav-item mx-0 mx-lg-1">
                            <a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded" href="#" @click.prevent="logout()">Sign out</a>
                        </li>
                        <li v-if="store.myUser" style="background: #2eb85c; border-radius: 0.25rem" class="nav-item mx-0 mx-lg-1">
                            <a class="nav-link js-scroll-trigger py-3 px-0 px-lg-3 rounded portal-button-text" :href="portalUrl">Portal</a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
        <header class="masthead" id="main">
            <div class="container">

                <template v-if="store.myUser">
                    <h5 class="section-heading">Hi {{ store.myUser.username }}, thank you for using RowerUp</h5>
                    <div class="masthead-subheading"></div>
                    <template v-if="0">
                        <a class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" :href="portalUrl">Portal</a>
                        <!-- The button appears just for mobuile -->
                    </template>
                    <div class="masthead-subheading"></div>
                </template>

                <h5 class="section-heading text-uppercase">FOR BOATs and ERGs</h5>
                <h5 class="section-heading text-uppercase">REFINE TECHNIQUE AND GET RECOMMENDATIONS FRAME BY FRAME</h5>
                <div class="masthead-subheading"></div>
                <h1 class="section-heading text-uppercase">THE WORLD'S MOST ADVANCED ROWING VIDEO<br>ANALYSIS AND TELESTRATION PLATFORM FOR<br>COACHES & ATHLETES</h1>
                <div class="masthead-subheading"></div>
                <h5 class="section-heading text-uppercase">Change your rowing technique and coach effectively in less time</h5>
                <div class="masthead-subheading"></div>

                <a v-if="!store.myUser" class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" :href="signUpUrl">Start for FREE</a>
            </div>
        </header>

        <div class="overlay"></div>
        <div class="embed-responsive embed-responsive-16by9">
            <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" controls controlslist="nodownload"
                   poster="../assets/main-page-assets/mp4/bg4-poster.jpg">
                <source src="../assets/main-page-assets/mp4/bg4.mp4" type="video/mp4" preload="auto">
            </video>
        </div>


        <section class="page-section bg-light" id="testimonials" href="#testimonials">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Elite coaches and athletes trust us</h2>
                    <h3 class="section-subheading text-muted">"Mate....I will happily rave about this to anyone I meet."
                    </h3>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/5.jpg" alt=""/>
                            <!-- <h5 class="section-heading text-uppercase">Mariano Tomas Kowalczyk, PAR</h5> -->
                            <h4>Thomas Lange, GER<br/><br/></h4>
                            <p class="text-muted">Olympic Gold<span style='font-size:16px;'>&#129351;&#129351;</span>: ’88’92 | Bronze<span style='font-size:16px;'>&#129353;</span>: ’96<br>
                                <!-- <br /> -->
                            </p>

                            <p class="text-muted text-justify show">"The program is a great help for improving one's own technique and best suited for
                                the coaches' work. I am very impressed!" <br>
                            </p>
                            <br />

                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/thomaslange4/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/12.jpg" alt="" />
                            <h4>Bernhard Stomporowski, GER<br/></h4>
                            <p class="text-muted">17x German Champion: '83-'99 <br> 3x&#129351;Gold: '89'90'98 | 1x&#129351;Silver:'87  | <br> 3x&#129353;Bronze:'92'94'95 World Champ<br>Olympian: 5th '96 - SM L4-</p>
                            <p class="text-muted">Tecnico Chefe Clube de Regatas do Flamengo<br>Tecnico Chefe Confederacao Brasileira de Remo (Brazilian Rowing Federation)</p>
                            <p class="text-muted text-justify show">"RowerUp made by an independent third party provides a professional and unbiased view. The feedback of the analysis is accurate and in many ways customizable for the coach. The athlete receives another reassurance of his doing and also a deeper understanding of the direction the coach wants him to develop."</p>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/hcflamengo/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a><a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/bernhard-stomporowski-1198b247/">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/6.jpg" alt="" />
                            <h4>Martino Goretti, ITA<br/><br /></h4>
                            <!-- <p class="text-muted">Olympian: 4th ’12’16</p> -->
                            <p class="text-muted">4x&#129351;Gold World Champ | Olympian:4th ’12’16</p>
                            <p class="text-muted text-justify show">"Rowerup is a Fantastic support for every athlete and coach, it makes technique analysis much more simple, and you can really go in the details, searching for the perfect stroke."</p>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/martinogoretti/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a><a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/martino-goretti-oly-790ba0b6/">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/2.jpg" alt=""/>
                            <!-- <h5 class="section-heading text-uppercase">Mariano Tomas Kowalczyk, PAR</h5> -->
                            <h4>Mariano Tomas Kowalczyk, PAR</h4>
                            <p class="text-muted">Head of Paraguayan Rowing Federation<br>
                                <!-- <br /> -->
                            </p>

                            <p class="text-muted text-justify show">"RowerUp is a tool that greatly simplifies traditional video analysis, it is easy
                                to use and the information provided is easy to understand. It is also a tool that can help in the motivation of rowers
                                to find the correct positions in the row, they can evaluate themselves and check their corrections."</p>

                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/mtkrow/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a><a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/mariano-tomas-kowalczyk-oly-68631a28/">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                        </a>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/9.jpg" alt="" />
                            <h4>Ricardo Cardoso, PT<br/><br /></h4>
                            <p class="text-muted">Sports scientist | Coach</p>
                            <p class="text-muted text-justify show">"RowerUp is a tool for coaches and rowers who wants to find extra speed. You can get a lot of details in one click.  It’s that easy! RowerUp is constantly upgrading their service to better serve the rowing community."</p>
                           <br />
                           <br />
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/ricardo_cardoso75/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a><a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/drcardoso/">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/11.jpg" alt="" />
                            <h4>Bendegúz Pétervári-Molnár, HU<br/></h4>
                            <p class="text-muted">Olympic single sculler:'16'21 <br> &#129351;Gold: University and Coastal World Champ<br>&#129351;Gold: U23 Europe | &#127942; 16xHungary Champ</p>
                            <p class="text-muted text-justify show">"RowerUp is the perfect support for every rower and coach. It’s very user-friendly and gives a thorough analysis of the rowing stroke. Totally recommend it to any rower from novices/amateurs to pros."</p>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/bendi61/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a><a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/bendeg%C3%BAz-p%C3%A9terv%C3%A1ri-moln%C3%A1r-a064b2a8/">
                            <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>



                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/4.jpg" alt=""/>
                            <h4>Borja Rueda, ESP<br/><br/></h4>
                            <p class="text-muted">Entrenador en Reial Club Nàutic de Tarragona</p>
                            <p class="text-muted text-justify show">"RowerUp is a useful tool in order to transmit with images and data those things
                                we observe while rowing. Apart from that, RowerUp has been interested in how to evolve the application and the reports
                                to make them understandable. Is very easy and fast to use in coaching."</p>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/borjika34/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.linkedin.com/in/borjarueda/">
                                <font-awesome-icon :icon="[ 'fab', 'linkedin-in' ]"></font-awesome-icon>
                            </a>

                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="team-member">
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="team-member">
                            <img class="mx-auto rounded-circle" src="../assets/main-page-assets/img/team/3.jpg" alt=""/>
                            <!-- <h5 class="section-heading text-uppercase">Axel Dickinson, NZ</h5> -->
                            <h4>Axel Dickinson, NZ</h4>
                            <p class="text-muted">Barbarian Rowing Club - President<br>
                                Hinksey Sculling School - Head Coach</p>
                            <p class="text-muted text-justify show" text-align="center">"Rower Up has been a helpful and effective tool in
                                coaching my athletes. We all best learn in different ways. My athletes being able to visually see how their
                                biomechanics compares to the ideal makes things simple and empowers them to self assess and make changes
                                accordingly."</p>
                            <a class="btn btn-dark btn-social mx-2" href="https://www.instagram.com/axel.dickinson/">
                                <font-awesome-icon :icon="[ 'fab', 'instagram' ]"></font-awesome-icon>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="team-member">
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-lg-8 mx-auto text-center"><p class="large text-muted">
                      "This tool would make a huge difference to my coaching. Seriously you've made my day,
                      I love stuff like this and am very impressed it was able to analyse so accurately even with the dark background with a black shirt on"
                    </p></div>
                </div> -->
                <div class="text-center">
                    <h3 class="section-subheading text-muted">"This tool would make a huge difference to my coaching."<br/>
                        <br/>
                        "You've made my day. It was able to analyse so accurately even with the dark background with a black shirt on."
                    </h3>
                </div>
            </div>
        </section>

        <section class="page-section" id="about">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Automatic Telestration, feedback, and analysis of video footage</h2>
                    <h6 class="section-heading text-uppercase">here's what you get</h6>
                    <h3 class="section-subheading text-muted"></h3>
                </div>
                <ul class="timeline">
                    <li class="timeline-inverted">
                        <div class="timeline-image"><img class="rounded-circle img-fluid"
                                                         src="../assets/main-page-assets/img/about/report_short.jpg"
                                                         alt=""/></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Advice for each stroke</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Precise recommendations from your footage</p></div>
                        </div>
                    </li>
                    <li>
                        <div class="timeline-image"><img class="rounded-circle img-fluid"
                                                         src="../assets/main-page-assets/img/about/adult-coach.jpg" alt=""/>
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Facilitates 1-on-1 and group coaching</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Directly communicate changes to your athletes</p></div>
                        </div>
                    </li>
                    <li class="timeline-inverted">
                        <div class="timeline-image"><img class="rounded-circle img-fluid"
                                                         src="../assets/main-page-assets/img/about/man-rowing-small.jpg"
                                                         alt=""/></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Solo training</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Train and progress with privacy</p></div>
                        </div>
                    </li>
                    <li>
                        <div class="timeline-image"><img class="rounded-circle img-fluid"
                                                         src="../assets/main-page-assets/img/about/report_short_2.jpg" alt=""/>
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Video and Networking</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Download and share performance progress</p></div>
                        </div>
                    </li>
                    <li class="timeline-inverted">
                        <div class="timeline-image"><img class="rounded-circle img-fluid"
                                                         src="../assets/main-page-assets/img/about/boat_and_erg.jpg"
                                                         alt=""/></div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Supports both erg and boat training</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Analyze footage from the lateral point of view</p></div>
                        </div>
                    </li>
                    <li @click="goToSignUpUrl()">
                        <div class="btn btn-primary timeline-image js-scroll-trigger">
                            <h4><br/>Sign Up!</h4>
                        </div>
                        <div class="timeline-panel">
                            <div class="timeline-heading">
                                <h4>Start for free</h4>
                            </div>
                            <div class="timeline-body"><p class="text-muted">Leave any time. We'll still be friends</p></div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="page-section" id="contact">
            <div class="container">
                <div class="text-center">
                    <h2 class="section-heading text-uppercase">Contact Us</h2>
                    <h3 class="section-subheading text-muted"></h3>
                </div>
                <form id="contactForm" @submit.prevent="onSubmit">
                    <div class="row align-items-stretch mb-5">
                        <div class="col-md-6">
                            <div class="form-group">
                                <input class="form-control" id="email" type="email" placeholder="Your Email" required
                                       v-model="contactUsForm.email"/>
                                <p class="help-block text-danger"></p>
                            </div>
                            <div class="form-group">
                                <input class="form-control" id="name" type="text" placeholder="Your Name"  required
                                       v-model="contactUsForm.name"/>
                                <p class="help-block text-danger"></p>
                            </div>
                            <div class="form-group mb-md-0">
                                <input class="form-control" id="occupation" type="text" placeholder="Are you a Coach or Athlete (or other)?"  required
                                       v-model="contactUsForm.occupation"/>
                                <p class="help-block text-danger"></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group form-group-textarea mb-md-0">
                                <textarea class="form-control" id="message" placeholder="Your Message" required
                                          v-model="contactUsForm.message"></textarea>
                                <p class="help-block text-danger"></p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <transition name="fade">
                            <div v-if="contactUsEmailWasSent" id="success">
                                <div class='alert alert-success'><strong>Your message has been sent. Thank you.</strong></div>
                            </div>
                        </transition>
                        <FormErrors :errors="errors" style="font-weight: bold; font-size: 1.53125rem"/>
                        <button class="btn btn-primary btn-xl text-uppercase" id="sendMessageButton" type="submit">Send Message</button>
                    </div>
                </form>
            </div>
        </section>
        <footer class="footer py-4" id="contact-us">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4 text-lg-left">info@rowerup.com <span style="margin-left: 1em">©</span> RowerUp {{ new Date().getFullYear() }}
                    </div>

                    <div class="col-lg-8 text-lg-right">
                        <a target="_blank" class="mr-3" :href="privacyPolicyUrl">Privacy Policy</a>
                        <a target="_blank" :href="termsOfUseUrl">Terms of Use</a>
                    </div>
                </div>
            </div>
        </footer>

    </div>
</template>


<script>
    import router from '@/plugins/router'
    import {
        getProcessedAuthResponseErrorsFlat,
        logout
    } from '@/scripts/auth-utils'
    import optionalAuthView from '@/mixins/optional-auth-view'
    import {onSubmitHandler} from '@/scripts/forms-utils'
    import gql from 'graphql-tag'
    import FormErrors from '@/components/FormErrors'

    export default {
        components: {FormErrors},
        mixins: [optionalAuthView],
        data() {
            return {
                pricingUrl: router.resolve({name: 'pricing'}).href,
                signUpUrl: router.resolve({name: 'signup', params: {tag: 'from-main'}}).href,
                loginUrl: router.resolve({name: 'login'}).href,
                portalUrl: router.resolve({name: 'feed'}).href,
                termsOfUseUrl: router.resolve({name: 'terms-of-use'}).href,
                privacyPolicyUrl: router.resolve({name: 'privacy-policy'}).href,
                errors: [],
                graphqlLoadingFlag: false,
                contactUsForm: {
                    email: '',
                    name: '',
                    occupation: '',
                    message: '',
                    source: 'MainPage'
                },
                contactUsEmailWasSent: false
            }
        },
        methods: {
            logout() {
                logout()
            },
            goToSignUpUrl() {
                router.push({name: 'signup', params: {tag: 'from-main'}})
            },
            async onSubmit() {
                let mutation = gql`
                        mutation contactUsRequest ($email: String!, $name: String!, $occupation: String!, $message: String!, $source: String!) {
                          contactUsRequest(email: $email, name: $name, occupation: $occupation, message: $message, source: $source){
                            success,
                            errors
                        }
                    }
                `

                await onSubmitHandler(this, mutation,
                    {
                        setErrorsF: (errors, scope) => scope.errors = getProcessedAuthResponseErrorsFlat(errors),
                        onSuccessF: (res, scope) => scope.contactUsEmailWasSent = true,
                        onStartF: (scope) => scope.contactUsEmailWasSent = false,
                        mutationVariables: this.contactUsForm
                    })
            }
        },
        mounted() {
            let script1 = document.createElement('script')
            script1.setAttribute('data-cookieconsent', 'ignore')
            script1.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js')

            let script2 = document.createElement('script')
            script2.setAttribute('data-cookieconsent', 'ignore')
            script2.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js')

            let script3 = document.createElement('script')
            script3.setAttribute('data-cookieconsent', 'ignore')
            script3.setAttribute('src', 'https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.bundle.min.js')

            let script4 = document.createElement('script')
            script4.setAttribute('data-cookieconsent', 'ignore')
            script4.setAttribute('src', '/static_main/scripts.js')

            script1.onload = () => {
                script2.onload = () => {
                    script3.onload = () => {
                        document.head.appendChild(script4)
                    }
                    document.head.appendChild(script3)
                }
                document.head.appendChild(script2)
            }
            document.head.appendChild(script1)
        },
    }
</script>
<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s .7S
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .portal-button-text:hover {
        color: #fff !important;
    }
</style>
